// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1EH3L","cell":"ColumnAccessor_cell__2z1Vg","firstCellAccent":"ColumnAccessor_firstCellAccent__3E95I"};